import { render } from "./ChooseAvatar.vue?vue&type=template&id=389f4b8e&scoped=true"
import script from "./ChooseAvatar.vue?vue&type=script&lang=js"
export * from "./ChooseAvatar.vue?vue&type=script&lang=js"

import "./ChooseAvatar.vue?vue&type=style&index=0&id=389f4b8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389f4b8e"]])

export default __exports__